(() => {
  if (customElements.get('related-products')) {
    return;
  }

  class relatedProducts extends HTMLElement {
    constructor() {
      super();

      this.mainProduct = document.querySelector('.main-product');
      this.mainProductDetails = this.mainProduct.querySelector('.main-product__details');
      this.mainProductForm = this.mainProductDetails.querySelector('product-form');
      this.mainProductBundleForms = [...this.mainProductDetails.querySelectorAll('.form-bundles')];
      this.mainProductVariantSelects = this.mainProductDetails.querySelector('variant-selects');
      this.mainProductQuantity = this.mainProductDetails.querySelector('quantity-input');
      this.relatedParent = this.querySelector('[data-related-parent]');
      this.productCards = this.querySelectorAll('product-card');
      this.hasBundle = [...this.productCards].some(card => ('productBundle' in card?.dataset));
      this.bundleSubmitBtn = this.mainProduct.querySelector(
        '[data-bundle-main-submit]'
      );
      this.relatedTotal = this.querySelector('[data-related-total]');
      this.submitButton = this.querySelector('[data-related-button]');
      this.submitButtonText = this.querySelector('[data-related-button] > span');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.discountSectionSelector = '?section_id=related-item-discounted'
    }

    connectedCallback() {
      this.submitButton.addEventListener('click', this.onSubmitHandler.bind(this));
      this.mainProductVariantSelects?.addEventListener('change', this.updateRelatedParentItemVariants.bind(this));
      this.mainProductQuantity?.addEventListener('change', this.updateRelatedParentItemQuantity.bind(this));

      [...this.productCards].forEach(item => {
        const checkbox = item.querySelector('[data-related-include]')?.querySelector('[type="checkbox"]');
        const variantSelects = item.querySelector('variant-selects');
        const isBundle = ('productBundle' in item?.dataset)

        // Hide original price if bundle is sold out and
        if (isBundle && this.bundleSubmitBtn) {
          const isSoldOut = this.bundleSubmitBtn.hasAttribute('disabled');
          const soldOutText = window.theme?.strings.product?.soldOut;

          if (isSoldOut && soldOutText) {
            const itemSelector = item.dataset?.productHandle;
            const priceWrapper = this.querySelector(
              `.product-card[data-product-handle="${itemSelector}"] .product-card__price-wrapper .money`
            );

            const copy = priceWrapper.cloneNode(true);
            copy.classList.remove('pre-money')
            copy.classList.remove('money')
            copy.classList.add('price__sold-out');
            copy.textContent = soldOutText;
            priceWrapper.parentElement.appendChild(copy)
            priceWrapper.classList.add('hidden');
          }
        }

        if (checkbox) {
          checkbox.addEventListener('change', this.updateButtonAdd.bind(this));
        }

        if (variantSelects) {
          variantSelects.addEventListener('change', this.updateTotalPrice.bind(this));
        }
      });
    }

    updateTotalPrice(event, targetElement = false) {
      this.handleErrorMessage();

      setTimeout(() => {
        const target = targetElement ? targetElement: event.target;
        const variantSelects = target.closest('variant-selects');
        const preFetchUrl =
          !!variantSelects
            ? variantSelects.dataset.priceTotal
            : `/products/${targetElement.dataset.productHandle}${this.discountSectionSelector}`
        let fetchUrl = `${preFetchUrl}&variants__`;

        [...this.productCards].forEach(item => {
          const handle = item.getAttribute('data-product-handle');
          const variantId = item.querySelector('[name="id"]').value;
          const quantity = item.querySelector('[name="quantity"]').value;
          const discount = item.querySelector('product-form')?.getAttribute('data-item-discount')?.split(':')[1] || 0;
          const isChecked = item.querySelector('[data-related-include]')?.querySelector('[type="checkbox"]').checked || false;

          if (isChecked) {
            fetchUrl += `${handle}_${variantId}+${discount}x${quantity}_0_`
          }
        });

        fetchUrl += '_1_';

        fetch(fetchUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const id = 'related-total-price';
            const html = new DOMParser().parseFromString(responseText, 'text/html')
            const destination = this.relatedTotal;
            const source = html.getElementById(id);
            if (source && destination) destination.innerHTML = source.innerHTML;
          });
      });
    }

    updateButtonAdd(event) {
      let checkedCount = 0;
      let allChecked = true;

      [...this.productCards].forEach(item => {
        const checkbox = item.querySelector('[data-related-include]')?.querySelector('[type="checkbox"]');
        const isChecked = checkbox.checked || false;

        if (isChecked) {
          checkedCount += 1;
        }
      });

      if (this.productCards.length !== checkedCount) {
        allChecked = false;
      }

      this.submitButton.toggleAttribute('disabled', (checkedCount === 0));

      const texts = this.submitButtonText.querySelectorAll('span');

      if (texts.length < 2) return;

      texts[0].toggleAttribute('hidden', !allChecked);
      texts[1].toggleAttribute('hidden', allChecked);

      this.updateTotalPrice(null, event.target.closest('product-card'));
    }

    updateRelatedParentItemVariants() {
      this.handleErrorMessage();
      this.relatedParent?.querySelector('variant-selects')?.dispatchEvent(
        new Event('change')
      );
    }

    updateRelatedParentItemQuantity() {
      this.relatedParent.querySelector('[name="quantity"]').value = this.mainProductQuantity?.querySelector('[name="quantity"]').value;
    }

    onSubmitHandler(event) {
      event.preventDefault();
      const items = [];
      const timeStamp = Date.now().toString();
      let checkedCount = 0;
      let firstForm = '';

      [...this.productCards].forEach((productCard, i) => {
        const id = productCard.querySelector('[name="id"]').value;
        const quantity = Number(productCard.querySelector('[name="quantity"]').value);
        const propsInputProduct = productCard.querySelector('.form-related__props-product');
        const propsInputCount = productCard.querySelector('.form-related__props-count');
        const isBundle = ('productBundle' in productCard?.dataset);

        const properties = {
          '_related_product': propsInputProduct.value,
          '_related_count': propsInputCount.value,
          '_related_stamp': timeStamp
        };
        const isChecked = productCard.querySelector('[data-related-include]')?.querySelector('[type="checkbox"]').checked || false;

        if (!isChecked) return;

        checkedCount += 1

        if (checkedCount === 1) {
          firstForm = productCard.querySelector('form');
          const timeStampInput = firstForm.querySelector('.form-related__props-stamp');
          timeStampInput.value = timeStamp;

          // Handle Bundle items
          if (isBundle && this.mainProductBundleForms.length) {
            this.mainProductBundleForms.forEach((form,i) => {
              if (i == 0) {
                firstForm = form;
                return;
              }
              const id = form.querySelector('[name="id"]').value;
              const quantity = Number(
                form.querySelector('[name="quantity"]').value
              );
              const propsInputProduct = form.querySelector(
                '.form-bundles__props-product'
              );
              const propsInputCount = form.querySelector(
                '.form-bundles__props-count'
              );

              const properties = {
                _related_product: propsInputProduct.value,
                _related_count: propsInputCount.value,
                _related_stamp: timeStamp,
              };

              items.push({
                id,
                quantity,
                properties,
              });

              checkedCount += 1;
            });
          }
        } else {
          items.push({
            id,
            quantity,
            properties
          });
        }
      });

      if (checkedCount === 1) {
        this.initBundledSectionRendering(firstForm);
      }

      if (checkedCount > 1 && items.length > 0) {
        const fetchedRelatedData = this.addRelatedItemsToCart(items);
        this.handleFetchedRelatedData(fetchedRelatedData, firstForm);
      }
    }

    addRelatedItemsToCart(items) {
      return new Promise((resolve, reject) => {
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
           'items': items
          })
        })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          if (response) {
            resolve(response);
            return;
          }

          reject(response);
        })
        .catch((error) => {
          window.console.error(error);
        });
      });
    }

    handleFetchedRelatedData(promise, form) {
      promise.then((values) => {
        if (values.length === 0) return;
        return values[0];
      })
      .then((data) => {
        this.initBundledSectionRendering(form);
      })
      .catch((error) => {
        window.console.error(error);
      });
    }

    initBundledSectionRendering(form) {
      if (!form) return;

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(form);

      if (window.theme.settings.cart_type == 'drawer') {
        formData.append('sections', this.cartDrawer.getSectionsToRender().map((section) => section.id));
      }

      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(window.Shopify.routes.root + 'cart/add.js', config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          if (window.theme.settings.cart_type == 'drawer') {
            this.cartDrawer.handleAddedItem(response);
          }
        })
        .catch((e) => {
          window.console.error(error);
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.querySelector('[data-related-error-message-wrapper]');

      if (!this.errorMessageWrapper) return;

      this.errorMessage = this.errorMessageWrapper.querySelector('[data-related-error-message]');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (!this.errorMessage) return;

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  }

  customElements.define('related-products', relatedProducts);
})();
